import i18n from '@i18next/i18n';
import { PATH_ANIM_TYPES } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import { AnimType, PresetId, PresetSubtype } from '@tencent/slide-sdk-model';

// 动画所处的两种播放状态：播放态和编辑态
export enum PLAY_MODE {
    play = 'play',
    edit = 'edit',
}

export const STYLE_VALUE = {
    positiveNum: 1,
    negativeNum: -1,
    zero: 0,
};
// 常用样式属性
export const ATTR_INIT = {
    opacityHide: { opacity: STYLE_VALUE.zero },
    opacityShow: { opacity: STYLE_VALUE.positiveNum },
    scaleInit: { scale: STYLE_VALUE.positiveNum, scaleX: STYLE_VALUE.positiveNum, scaleY: STYLE_VALUE.positiveNum },
};

export const FLIP_DEFAULT = STYLE_VALUE.positiveNum;

export const ENTRY_REVOLVE_INIT_Y_RATE = 0.31; // 入场-中心旋转-y轴的初始比例

// 动画编辑面板常量
export const ENTR_ANIM_GROUP = {
    [AnimType.Appear]: i18n.t('出现'),
    [AnimType.FadeIn]: i18n.t('淡入'),
    [AnimType.FlyIn]: i18n.t('飞入'),
    [AnimType.FloatUpIn]: i18n.t('浮入'),
    [AnimType.CutIn]: i18n.t('切入动画'),
    [AnimType.EntrRandomBars]: i18n.t('随机线条'),
    [AnimType.EntrWipe]: i18n.t('擦除'),
    [AnimType.Spread]: i18n.t('展开'),
    [AnimType.EnterRotate]: i18n.t('旋转'),
    [AnimType.EnterScale]: i18n.t('缩放'),
    [AnimType.EntrCenterRevolve]: i18n.t('中心旋转'),
    [AnimType.EntrGrowTurn]: i18n.t('翻转式由远及近'),
    [AnimType.EntrRiseUp]: i18n.t('升起'),
    [AnimType.EntrSpinner]: i18n.t('回旋'),
    [AnimType.EntrBasicZoom]: i18n.t('基本缩放'),
    [AnimType.EntrStretch]: i18n.t('伸展'),
    [AnimType.EntrBoomerang]: i18n.t('飞旋'),
    [AnimType.EntrPinwheel]: i18n.t('玩具风车'),
    [AnimType.EntrBasicSwivel]: i18n.t('基本旋转'),
    [AnimType.EntrCredits]: i18n.t('字幕式'),
    [AnimType.EntrBlinds]: i18n.t('百叶窗'),
    [AnimType.EntrCheckerboard]: i18n.t('棋盘'),
    [AnimType.EntrFloat]: i18n.t('浮动'),
    [AnimType.CurveUp]: i18n.t('曲线向上'),
    [AnimType.DissolveIn]: i18n.t('向内溶解'),
    [AnimType.EntrSplit]: i18n.t('劈裂'),
    [AnimType.EntrStrips]: i18n.t('阶梯状'),
    [AnimType.EntrWedge]: i18n.t('楔入'),
    // 不同形状均以形状代替，退出同理
    [AnimType.EntrShapeCircle]: i18n.t('形状'),
    [AnimType.EntrShapeBox]: i18n.t('形状'),
    [AnimType.EntrShapeDiamond]: i18n.t('形状'),
    [AnimType.EntrShapePlus]: i18n.t('形状'),
    [AnimType.EntrWheel]: i18n.t('轮子'),
    [AnimType.SpiralIn]: i18n.t('旋转飞入'),
    [AnimType.EntrBounce]: i18n.t('弹跳'),
};

export const EMPH_ANIM_GROUP = {
    [AnimType.Scale]: i18n.t('放大/缩小'),
    [AnimType.Rotate]: i18n.t('陀螺旋'),
    [AnimType.Plus]: i18n.t('脉冲'),
    [AnimType.EmphTransparency]: i18n.t('透明'),
};

export const EXIT_ANIM_GROUP = {
    [AnimType.Disappear]: i18n.t('消失'),
    [AnimType.FadeOut]: i18n.t('淡出'),
    [AnimType.FlyOut]: i18n.t('飞出'),
    [AnimType.CutOut]: i18n.t('切出动画'),
    [AnimType.ExitRandomBars]: i18n.t('随机线条'),
    [AnimType.ExitWipe]: i18n.t('擦除'),
    [AnimType.FloatDownOut]: i18n.t('浮出'),
    [AnimType.ExitSpread]: i18n.t('收缩'),
    [AnimType.ExitRotate]: i18n.t('旋转'),
    [AnimType.ExitScale]: i18n.t('缩放'),
    [AnimType.ExitCenterRevolve]: i18n.t('中心旋转'),
    [AnimType.ExitCollapse]: i18n.t('层叠'),
    [AnimType.ExitShrinkTurn]: i18n.t('收缩并旋转'),
    [AnimType.ExitSinkDown]: i18n.t('下沉'),
    [AnimType.ExitSpinner]: i18n.t('回旋'),
    [AnimType.ExitBasicZoom]: i18n.t('基本缩放'),
    [AnimType.ExitStretch]: i18n.t('伸缩'),
    [AnimType.ExitBoomerang]: i18n.t('飞旋'),
    [AnimType.ExitPinwheel]: i18n.t('玩具风车'),
    [AnimType.ExitBasicSwivel]: i18n.t('基本旋转'),
    [AnimType.ExitCredits]: i18n.t('字幕式'),
    [AnimType.ExitBlinds]: i18n.t('百叶窗'),
    [AnimType.ExitCheckerboard]: i18n.t('棋盘'),
    [AnimType.ExitFloat]: i18n.t('浮动'),
    [AnimType.CurveDown]: i18n.t('向下曲线'),
    [AnimType.DissolveOut]: i18n.t('向外溶解'),
    [AnimType.ExitSplit]: i18n.t('劈裂'),
    [AnimType.ExitStrips]: i18n.t('阶梯状'),
    [AnimType.ExitWedge]: i18n.t('楔入'),
    [AnimType.ExitShapeCircle]: i18n.t('形状'),
    [AnimType.ExitShapeBox]: i18n.t('形状'),
    [AnimType.ExitShapeDiamond]: i18n.t('形状'),
    [AnimType.ExitShapePlus]: i18n.t('形状'),
    [AnimType.ExitWheel]: i18n.t('轮子'),
    [AnimType.SpiralOut]: i18n.t('旋转飞出'),
    [AnimType.ExitBounce]: i18n.t('弹跳'),
};

export const PATH_ANIM_GROUP = {
    [PATH_ANIM_TYPES.ARC]: i18n.t('弧形'),
    [PATH_ANIM_TYPES.STRAIGHT_LINE]: i18n.t('直线'),
    [PATH_ANIM_TYPES.CYCLE]: i18n.t('循环'),
    [PATH_ANIM_TYPES.SHAPE]: i18n.t('形状'),
    [PATH_ANIM_TYPES.TURN]: i18n.t('转弯'),
    [PATH_ANIM_TYPES.CUSTOM]: i18n.t('自定义路径'),
};
export const ANIM_TYPE_TEXT = {
    ...ENTR_ANIM_GROUP,
    ...EMPH_ANIM_GROUP,
    ...EXIT_ANIM_GROUP,
    ...PATH_ANIM_GROUP,
    [AnimType.FloatUpOut]: i18n.t('浮出'),
    [AnimType.FloatDownIn]: i18n.t('浮入'),
    [AnimType.CutIn]: i18n.t('切入动画'),
    [AnimType.CutOut]: i18n.t('切出动画'),
    [AnimType.Play]: i18n.t('控制播放'),
    [AnimType.Pause]: i18n.t('控制切换'),
    [AnimType.Stop]: i18n.t('控制停止'),
    [AnimType.FillColor]: i18n.t('填充颜色'),
    [AnimType.FontColor]: i18n.t('字体颜色'),
    [AnimType.LineColor]: i18n.t('线条颜色'),
    [AnimType.BrushColor]: i18n.t('画笔颜色'),
    [AnimType.ComplementaryColor]: i18n.t('补色'),
    [AnimType.ComplementaryColor2]: i18n.t('补色2'),
    [AnimType.ContrastingColor]: i18n.t('对比色'),
    [AnimType.Darken]: i18n.t('加深'),
    [AnimType.Desaturate]: i18n.t('不饱和'),
    [AnimType.Lighten]: i18n.t('变淡'),
    [AnimType.ObjectColor]: i18n.t('对象颜色'),
    [AnimType.ColorPulse]: i18n.t('彩色脉冲'),
    [AnimType.GrowWithColor]: i18n.t('彩色延伸'),
};

export const ANIM_ITEM_TEXT = {
    NONE: '',
    [AnimType.FlyIn + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FlyIn + PresetSubtype.Bottom]: i18n.t('从下方'),
    [AnimType.FlyIn + PresetSubtype.Right]: i18n.t('从右方'),
    [AnimType.FlyIn + PresetSubtype.Left]: i18n.t('从左方'),
    [AnimType.FlyIn + PresetSubtype.TopLeft]: i18n.t('从左上方'),
    [AnimType.FlyIn + PresetSubtype.TopRight]: i18n.t('从右上方'),
    [AnimType.FlyIn + PresetSubtype.BottomLeft]: i18n.t('从左下方'),
    [AnimType.FlyIn + PresetSubtype.BottomRight]: i18n.t('从右下方'),

    [AnimType.FlyOut + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FlyOut + PresetSubtype.Bottom]: i18n.t('从下方'),
    [AnimType.FlyOut + PresetSubtype.Right]: i18n.t('从右方'),
    [AnimType.FlyOut + PresetSubtype.Left]: i18n.t('从左方'),
    [AnimType.FlyOut + PresetSubtype.TopLeft]: i18n.t('从左上方'),
    [AnimType.FlyOut + PresetSubtype.TopRight]: i18n.t('从右上方'),
    [AnimType.FlyOut + PresetSubtype.BottomLeft]: i18n.t('从左下方'),
    [AnimType.FlyOut + PresetSubtype.BottomRight]: i18n.t('从右下方'),

    [AnimType.Scale + PresetSubtype.LeftRight]: i18n.t('水平'),
    [AnimType.Scale + PresetSubtype.TopBottom]: i18n.t('上下'),
    [AnimType.Scale + PresetSubtype.Total]: i18n.t('整体'),

    [AnimType.FloatUpIn + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FloatUpIn + PresetSubtype.Bottom]: i18n.t('从下方'),
    [AnimType.FloatDownIn + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FloatDownIn + PresetSubtype.Bottom]: i18n.t('从下方'),
    [AnimType.FloatUpOut + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FloatUpOut + PresetSubtype.Bottom]: i18n.t('从下方'),
    [AnimType.FloatDownOut + PresetSubtype.Top]: i18n.t('从上方'),
    [AnimType.FloatDownOut + PresetSubtype.Bottom]: i18n.t('从下方'),

    [AnimType.EntrWipe + PresetSubtype.Top]: i18n.t('从顶端'),
    [AnimType.EntrWipe + PresetSubtype.Right]: i18n.t('从右侧'),
    [AnimType.EntrWipe + PresetSubtype.Bottom]: i18n.t('从底端'),
    [AnimType.EntrWipe + PresetSubtype.Left]: i18n.t('从左侧'),
    [AnimType.ExitWipe + PresetSubtype.Top]: i18n.t('从顶端'),
    [AnimType.ExitWipe + PresetSubtype.Right]: i18n.t('从右侧'),
    [AnimType.ExitWipe + PresetSubtype.Bottom]: i18n.t('从底端'),
    [AnimType.ExitWipe + PresetSubtype.Left]: i18n.t('从左侧'),

    [AnimType.CutIn + PresetSubtype.Top]: i18n.t('从顶部'),
    [AnimType.CutIn + PresetSubtype.Right]: i18n.t('从右侧'),
    [AnimType.CutIn + PresetSubtype.Bottom]: i18n.t('从底部'),
    [AnimType.CutIn + PresetSubtype.Left]: i18n.t('从左侧'),
    [AnimType.CutOut + PresetSubtype.Top]: i18n.t('到顶部'),
    [AnimType.CutOut + PresetSubtype.Right]: i18n.t('到右侧'),
    [AnimType.CutOut + PresetSubtype.Bottom]: i18n.t('到底部'),
    [AnimType.CutOut + PresetSubtype.Left]: i18n.t('到左侧'),

    [AnimType.EntrRandomBars + PresetSubtype.Vertical]: i18n.t('垂直'),
    [AnimType.EntrRandomBars + PresetSubtype.Across]: i18n.t('水平'),
    [AnimType.ExitRandomBars + PresetSubtype.Vertical]: i18n.t('垂直'),
    [AnimType.ExitRandomBars + PresetSubtype.Across]: i18n.t('水平'),

    [AnimType.Rotate + PresetSubtype.Clockwise]: i18n.t('顺时针'),
    [AnimType.Rotate + PresetSubtype.Counterclockwise]: i18n.t('逆时针'),

    [AnimType.EnterScale + PresetSubtype.EleCenter]: i18n.t('对象中心'),
    [AnimType.EnterScale + PresetSubtype.SlideCenter]: i18n.t('幻灯片中心'),

    [AnimType.ExitScale + PresetSubtype.ToEleCenter]: i18n.t('向外'),
    [AnimType.ExitScale + PresetSubtype.ToSlideCenter]: i18n.t('缩小到屏幕中心'),

    [AnimType.EntrBasicZoom + PresetSubtype.EleCenter]: i18n.t('向内'),
    [AnimType.EntrBasicZoom + PresetSubtype.SlideCenter]: i18n.t('从屏幕中心放大'),
    [AnimType.EntrBasicZoom + PresetSubtype.InSlightly]: i18n.t('轻微放大'),
    [AnimType.EntrBasicZoom + PresetSubtype.ToEleCenter]: i18n.t('向外'),
    [AnimType.EntrBasicZoom + PresetSubtype.OutBottom]: i18n.t('从屏幕底部缩小'),
    [AnimType.EntrBasicZoom + PresetSubtype.OutSlightly]: i18n.t('轻微缩小'),

    [AnimType.EntrStretch + PresetSubtype.Across]: i18n.t('跨'),
    [AnimType.EntrStretch + PresetSubtype.Top]: i18n.t('从顶端'),
    [AnimType.EntrStretch + PresetSubtype.Bottom]: i18n.t('从底端'),
    [AnimType.EntrStretch + PresetSubtype.Left]: i18n.t('从左侧'),
    [AnimType.EntrStretch + PresetSubtype.Right]: i18n.t('从右侧'),

    [AnimType.EntrBasicSwivel + PresetSubtype.Across]: i18n.t('水平'),
    [AnimType.EntrBasicSwivel + PresetSubtype.Vertical]: i18n.t('垂直'),

    [AnimType.ExitBasicZoom + PresetSubtype.ToEleCenter]: i18n.t('向外'),
    [AnimType.ExitBasicZoom + PresetSubtype.ToSlideCenter]: i18n.t('缩小到屏幕中心'),
    [AnimType.ExitBasicZoom + PresetSubtype.OutSlightly]: i18n.t('轻微缩小'),
    [AnimType.ExitBasicZoom + PresetSubtype.EleCenter]: i18n.t('向内'),
    [AnimType.ExitBasicZoom + PresetSubtype.ToSlideBottom]: i18n.t('放大到屏幕底部'),
    [AnimType.ExitBasicZoom + PresetSubtype.InSlightly]: i18n.t('轻微放大'),

    [AnimType.ExitCollapse + PresetSubtype.Across]: i18n.t('跨'),
    [AnimType.ExitCollapse + PresetSubtype.Top]: i18n.t('到顶端'),
    [AnimType.ExitCollapse + PresetSubtype.Bottom]: i18n.t('到底端'),
    [AnimType.ExitCollapse + PresetSubtype.Left]: i18n.t('到左侧'),
    [AnimType.ExitCollapse + PresetSubtype.Right]: i18n.t('到右侧'),

    [AnimType.ExitBasicSwivel + PresetSubtype.Across]: i18n.t('水平'),
    [AnimType.ExitBasicSwivel + PresetSubtype.Vertical]: i18n.t('垂直'),

    [AnimType.EntrBlinds + PresetSubtype.Across]: i18n.t('水平'),
    [AnimType.EntrBlinds + PresetSubtype.Vertical]: i18n.t('垂直'),
    [AnimType.ExitBlinds + PresetSubtype.Across]: i18n.t('水平'),
    [AnimType.ExitBlinds + PresetSubtype.Vertical]: i18n.t('垂直'),
    [AnimType.EntrCheckerboard + PresetSubtype.Across]: i18n.t('横跨'),
    [AnimType.ExitCheckerboard + PresetSubtype.Across]: i18n.t('横跨'),
    [AnimType.EntrCheckerboard + PresetSubtype.Vertical]: i18n.t('下'),
    [AnimType.ExitCheckerboard + PresetSubtype.Vertical]: i18n.t('上'),

    [AnimType.EntrSplit + PresetSubtype.VerticalIn]: i18n.t('左右向中央收缩'),
    [AnimType.EntrSplit + PresetSubtype.VerticalOut]: i18n.t('中央向左右展开'),
    [AnimType.EntrSplit + PresetSubtype.HorizontalIn]: i18n.t('上下向中央收缩'),
    [AnimType.EntrSplit + PresetSubtype.HorizontalOut]: i18n.t('中央向上下展开'),
    [AnimType.ExitSplit + PresetSubtype.VerticalIn]: i18n.t('左右向中央收缩'),
    [AnimType.ExitSplit + PresetSubtype.VerticalOut]: i18n.t('中央向左右展开'),
    [AnimType.ExitSplit + PresetSubtype.HorizontalIn]: i18n.t('上下向中央收缩'),
    [AnimType.ExitSplit + PresetSubtype.HorizontalOut]: i18n.t('中央向上下展开'),

    [AnimType.EntrStrips + PresetSubtype.TopLeft]: i18n.t('阶梯状方向.左上'),
    [AnimType.EntrStrips + PresetSubtype.BottomLeft]: i18n.t('阶梯状方向.左下'),
    [AnimType.EntrStrips + PresetSubtype.TopRight]: i18n.t('阶梯状方向.右上'),
    [AnimType.EntrStrips + PresetSubtype.BottomRight]: i18n.t('阶梯状方向.右下'),
    [AnimType.ExitStrips + PresetSubtype.TopLeft]: i18n.t('阶梯状方向.左上'),
    [AnimType.ExitStrips + PresetSubtype.BottomLeft]: i18n.t('阶梯状方向.左下'),
    [AnimType.ExitStrips + PresetSubtype.TopRight]: i18n.t('阶梯状方向.右上'),
    [AnimType.ExitStrips + PresetSubtype.BottomRight]: i18n.t('阶梯状方向.右下'),

    [AnimType.EntrShapeCircle + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.EntrShapeCircle + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),
    [AnimType.ExitShapeCircle + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.ExitShapeCircle + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),

    [AnimType.EntrShapeBox + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.EntrShapeBox + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),
    [AnimType.ExitShapeBox + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.ExitShapeBox + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),

    [AnimType.EntrShapeDiamond + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.EntrShapeDiamond + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),
    [AnimType.ExitShapeDiamond + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.ExitShapeDiamond + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),

    [AnimType.EntrShapePlus + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.EntrShapePlus + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),
    [AnimType.ExitShapePlus + PresetSubtype.EleCenter]: i18n.t('形状动画.缩小'),
    [AnimType.ExitShapePlus + PresetSubtype.ToEleCenter]: i18n.t('形状动画.放大'),

    [AnimType.EntrWheel + PresetSubtype.Top]: i18n.t('1 轮幅图案'),
    [AnimType.EntrWheel + PresetSubtype.Right]: i18n.t('2 轮幅图案'),
    [AnimType.EntrWheel + PresetSubtype.TopRight]: i18n.t('3 轮幅图案'),
    [AnimType.EntrWheel + PresetSubtype.Bottom]: i18n.t('4 轮幅图案'),
    [AnimType.EntrWheel + PresetSubtype.Left]: i18n.t('8 轮幅图案'),
    [AnimType.ExitWheel + PresetSubtype.Top]: i18n.t('1 轮幅图案'),
    [AnimType.ExitWheel + PresetSubtype.Right]: i18n.t('2 轮幅图案'),
    [AnimType.ExitWheel + PresetSubtype.TopRight]: i18n.t('3 轮幅图案'),
    [AnimType.ExitWheel + PresetSubtype.Bottom]: i18n.t('4 轮幅图案'),
    [AnimType.ExitWheel + PresetSubtype.Left]: i18n.t('8 轮幅图案'),
};

export const ANIM_TO_SUB_DIR = {
    [AnimType.Appear]: [],
    [AnimType.Disappear]: [],
    [AnimType.FadeIn]: [],
    [AnimType.FadeOut]: [],
    [AnimType.Scale]: [
        PresetSubtype.LeftRight,
        PresetSubtype.TopBottom,
        PresetSubtype.Total],
    [AnimType.FlyIn]: [
        PresetSubtype.Left,
        PresetSubtype.Right,
        PresetSubtype.Top,
        PresetSubtype.Bottom,
        PresetSubtype.TopLeft,
        PresetSubtype.TopRight,
        PresetSubtype.BottomLeft,
        PresetSubtype.BottomRight],
    [AnimType.FlyOut]: [
        PresetSubtype.Left,
        PresetSubtype.Right,
        PresetSubtype.Top,
        PresetSubtype.Bottom,
        PresetSubtype.TopLeft,
        PresetSubtype.TopRight,
        PresetSubtype.BottomLeft,
        PresetSubtype.BottomRight],
    [AnimType.CutIn]: [PresetSubtype.Left, PresetSubtype.Right, PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.CutOut]: [PresetSubtype.Left, PresetSubtype.Right, PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.FloatUpIn]: [PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.FloatUpOut]: [PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.FloatDownIn]: [PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.FloatDownOut]: [PresetSubtype.Top, PresetSubtype.Bottom],
    [AnimType.Plus]: [],
    [AnimType.Rotate]: [PresetSubtype.Clockwise, PresetSubtype.Counterclockwise],
    [AnimType.EnterScale]: [PresetSubtype.EleCenter, PresetSubtype.SlideCenter],
    [AnimType.ExitScale]: [PresetSubtype.ToEleCenter, PresetSubtype.ToSlideCenter],
    [AnimType.EntrBasicZoom]: [
        PresetSubtype.EleCenter,
        PresetSubtype.SlideCenter,
        PresetSubtype.InSlightly,
        PresetSubtype.ToEleCenter,
        PresetSubtype.OutBottom,
        PresetSubtype.OutSlightly,
    ],
    [AnimType.EntrStretch]: [
        PresetSubtype.Across,
        PresetSubtype.Top,
        PresetSubtype.Bottom,
        PresetSubtype.Left,
        PresetSubtype.Right,
    ],
    [AnimType.ExitBasicZoom]: [
        PresetSubtype.ToEleCenter,
        PresetSubtype.ToSlideCenter,
        PresetSubtype.OutSlightly,
        PresetSubtype.EleCenter,
        PresetSubtype.ToSlideBottom,
        PresetSubtype.InSlightly,
    ],
    [AnimType.ExitCollapse]: [
        PresetSubtype.Across,
        PresetSubtype.Top,
        PresetSubtype.Bottom,
        PresetSubtype.Left,
        PresetSubtype.Right,
    ],
    [AnimType.ExitBasicSwivel]: [PresetSubtype.Across,  PresetSubtype.Vertical],
    [AnimType.EntrBasicSwivel]: [PresetSubtype.Across,  PresetSubtype.Vertical],

    [AnimType.EntrBlinds]: [PresetSubtype.Across,  PresetSubtype.Vertical],
    [AnimType.ExitBlinds]: [PresetSubtype.Across,  PresetSubtype.Vertical],
    [AnimType.EntrCheckerboard]: [PresetSubtype.Across, PresetSubtype.Vertical],
    [AnimType.ExitCheckerboard]: [PresetSubtype.Across, PresetSubtype.Vertical],
    [AnimType.EntrWipe]: [PresetSubtype.Bottom, PresetSubtype.Left, PresetSubtype.Right, PresetSubtype.Top],
    [AnimType.ExitWipe]: [PresetSubtype.Bottom, PresetSubtype.Left, PresetSubtype.Right, PresetSubtype.Top],

    [AnimType.EntrRandomBars]: [PresetSubtype.Across, PresetSubtype.Vertical],
    [AnimType.ExitRandomBars]: [PresetSubtype.Across, PresetSubtype.Vertical],
    [AnimType.DissolveIn]: [],
    [AnimType.DissolveOut]: [],
    [AnimType.EntrWedge]: [],
    [AnimType.ExitWedge]: [],

    [AnimType.EntrSplit]: [
        PresetSubtype.HorizontalIn,
        PresetSubtype.HorizontalOut,
        PresetSubtype.VerticalIn,
        PresetSubtype.VerticalOut,
    ],
    [AnimType.ExitSplit]: [
        PresetSubtype.HorizontalIn,
        PresetSubtype.HorizontalOut,
        PresetSubtype.VerticalIn,
        PresetSubtype.VerticalOut,
    ],

    [AnimType.EntrStrips]: [
        PresetSubtype.BottomLeft,
        PresetSubtype.TopLeft,
        PresetSubtype.BottomRight,
        PresetSubtype.TopRight,
    ],
    [AnimType.ExitStrips]: [
        PresetSubtype.BottomLeft,
        PresetSubtype.TopLeft,
        PresetSubtype.BottomRight,
        PresetSubtype.TopRight,
    ],

    [AnimType.EntrShapeCircle]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.ExitShapeCircle]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.EntrShapeBox]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.ExitShapeBox]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.EntrShapeDiamond]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.ExitShapeDiamond]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.EntrShapePlus]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],
    [AnimType.ExitShapePlus]: [PresetSubtype.EleCenter, PresetSubtype.ToEleCenter],

    [AnimType.EntrWheel]: [
        PresetSubtype.Top,
        PresetSubtype.Right,
        PresetSubtype.TopRight,
        PresetSubtype.Bottom,
        PresetSubtype.Left,
    ],
    [AnimType.ExitWheel]: [
        PresetSubtype.Top,
        PresetSubtype.Right,
        PresetSubtype.TopRight,
        PresetSubtype.Bottom,
        PresetSubtype.Left,
    ],
};

// 形状动画对应的各种形状
export const SHAPE_LIST = [
    { id: PresetId.ScaleOrCircle, label: i18n.t('形状动画.圆形') },
    { id: PresetId.Box, label: i18n.t('形状动画.方框') },
    { id: PresetId.RotateOrDiamond, label: i18n.t('形状动画.菱形') },
    { id: PresetId.Plus, label: i18n.t('形状动画.加号') },
];

export const INIT_STYLE = {
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    rotateX: 0,
    rotateY: 0,
    opacity: 1,
    translateX: 0,
    translateY: 0,
};

export const ANIM_STATE = {
    START: 'start', // 动画开始
    COMPLETE: 'complete', // 动画结束
};

export const CHILD_TL = 'childTl';

export const ANIM_PROPERTY = {
    TRANSLATE_X: 'translateX',
    TRANSLATE_Y: 'translateY',
    ROTATE: 'rotate',
    OPACITY: 'opacity',
    SCALE_X: 'scaleX',
    SCALE_Y: 'scaleY',
};

export const CON_EVT = {
    onClick: 'onClick',
};

export const ANIM_QUEUE_LABEL = {
    fragmentLengthInfos: 'fragmentLengthInfos',
    iaFragmentLengthInfos: 'iaFragmentLengthInfos',
};

export const ANIM_PATH = {
    timing: '/timing',
    tmRoot: '/tmRoot',
};

export const otherEffectKeyArr = [
    AnimType.FlyOut,
    AnimType.FlyIn,
    AnimType.FloatUpIn,
    AnimType.FloatUpOut,
    AnimType.FloatDownIn,
    AnimType.FloatDownOut,
    AnimType.Plus,
    AnimType.Rotate,
    AnimType.Spread,
    AnimType.EnterRotate,
    AnimType.EnterScale,
    AnimType.ExitSpread,
    AnimType.ExitRotate,
    AnimType.ExitScale,
    AnimType.EntrCenterRevolve,
    AnimType.EntrGrowTurn,
    AnimType.EntrRiseUp,
    AnimType.EntrSpinner,
    AnimType.EntrBasicZoom,
    AnimType.EntrStretch,
    AnimType.ExitCenterRevolve,
    AnimType.ExitCollapse,
    AnimType.ExitShrinkTurn,
    AnimType.ExitSinkDown,
    AnimType.ExitSpinner,
    AnimType.ExitBasicZoom,
    AnimType.ExitStretch,
    AnimType.EntrBoomerang,
    AnimType.EntrPinwheel,
    AnimType.EntrBasicSwivel,
    AnimType.ExitBoomerang,
    AnimType.ExitPinwheel,
    AnimType.ExitBasicSwivel,
    AnimType.EmphTransparency,
    AnimType.EntrCredits,
    AnimType.ExitCredits,
    // ANIM_TYPES.CURVE_UP,
    // ANIM_TYPES.CURVE_DOWN,
];


// 13个颜色类动画通过转换器统一实现
export const colorAnimTypeList = [
    AnimType.FillColor,
    AnimType.FontColor,
    AnimType.LineColor,
    AnimType.BrushColor,
    AnimType.ComplementaryColor,
    AnimType.ComplementaryColor2,
    AnimType.ContrastingColor,
    AnimType.Darken,
    AnimType.Desaturate,
    AnimType.Lighten,
    AnimType.ObjectColor,
    AnimType.ColorPulse,
    AnimType.GrowWithColor,
];
